import { styled } from '@mui/system';
import ButtonUI from '@mui/material/Button';
import { Theme } from '@mui/material';
import LoadingButtonUI from '@mui/lab/LoadingButton';

type ParamsStyle = {
    theme?: Theme;
    paddingx?: string;
    selectedstyle?: string;
}

export const ButtonCustom = styled(ButtonUI)(
    ({ theme, selectedstyle }: ParamsStyle) => `
    font-size: 1rem;
    height: 2.8125rem;
    line-height: 1;
    padding: 0px;
    padding-top: 4px;
    font-weight: 700;
    border-radius: 5px;
    text-transform: none;
    color: ${theme?.palette.primary.main};

    &:disabled {
        color: #FFFFFF;
        background-color: ${theme?.palette.grey[50]};
        border: 1.5px solid ${theme?.palette.grey[50]};
    }

    border: ${selectedstyle === 'active' ? `1.5px solid ${theme?.palette.secondary.main}` : `1.5px solid ${theme?.palette.primary.main}`};
    
    :hover {
        border: ${selectedstyle === 'active' ? `1.5px solid ${theme?.palette.secondary.main}` : `1.5px solid ${theme?.palette.primary.main}`};
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        height: 2.3rem;
    }

    @media(min-width: ${theme?.breakpoints.values.lg}px) {
        height: 2.8125rem;
    }
`);

export const LoadingButton = styled(LoadingButtonUI)(
    ({ theme }) => `
    height: 2.8125rem;
    border-radius: 5px;

    span {
        width: 22px !important;
        height: 22px !important;
        color: #FFFFFF;
    }

    &:disabled {
        background-color: ${theme?.palette.grey[50]};
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        height: 2.3rem;
    }

    @media(min-width: ${theme?.breakpoints.values.lg}px) {
        height: 2.8125rem;
    }
`);

export const ButtonCustomCircle = styled(ButtonUI)(
    ({ theme, selectedstyle }: ParamsStyle) => `
    width: 6.625rem;
    height: 1.875rem;
    font-size: .875rem;
    line-height: 1;
    font-weight: 700;
    border-radius: 100px;

    font-weight: ${selectedstyle === 'active' ? 700 : 400};
    color: ${selectedstyle === 'active' ? "#FFFFFF" : theme?.palette.grey[400]};
    background: ${selectedstyle === 'active' ? theme?.palette.primary.main : '#FFFFFF'};
    border: ${selectedstyle === 'active' ? `1.5px solid ${theme?.palette.primary.main}` : `1.5px solid ${theme?.palette.grey[400]}`};

    :hover {
        background: ${selectedstyle === 'active' ? theme?.palette.primary.main : '#FFFFFF'};
    }
`);